export default __webpack_public_path__ + "static/media/paysage1.393e93cd.jpg";